// anything but production: dev, qa and staging builds, local runs and the test suite
export const isTestingEnvironment = (): boolean => process.env.REACT_APP_ENV !== 'production';
